angular.module('picmonicng').directive('functionOnEnter', function () {
  return function (scope, element, attrs) {
    element.bind('keypress', function (event) {
      if (event.which === 13 && !event.shiftKey) {
        scope.$apply(function () {
          scope.$eval(attrs.functionOnEnter, { event: event });
        });

        event.preventDefault();
      }
    });
  };
});
